import React, { useState } from "react";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import axiosInstance from "../utils/axiosInstance";
import bgImage from "../assets/bg.png";

const SignUp = () => {
    const [formData, setFormData] = useState({
        username: "",
        email: "",
        password: "",
    });

    const navigate = useNavigate();

    // Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const { username, email, password } = formData;
    
        // Prepare request data
        const requestData = { username, email, password };
    
        try {
            const response = await axiosInstance.post("/user/signup", requestData);
    
            if (response.status === 201) {
                toast.success(response.data.message);
                navigate("/signin");
            } else {
                toast.error(`Signup failed: ${response.data.error || "Unknown error"}`);
            }
        } catch (error) {
            console.error(error);
            
            // Extract error message from backend response
            if (error.response) {
                const errorMessage = error.response.data?.error || "Signup failed. Please try again.";
                toast.error(`Signup failed: ${errorMessage}`);
            } else {
                toast.error("Signup failed. No response from server.");
            }
        }
    };

    return (
        <div
            className="flex flex-col items-center justify-center min-h-screen bg-gray-100 bg-cover bg-center"
            style={{ backgroundImage: `url(${bgImage})` }}
        >
            <div className="bg-white p-6 rounded-lg shadow-md w-full max-w-md">
                <ChevronLeft
                    onClick={() => navigate("/")}
                    className="h-8 w-8 cursor-pointer text-gray-400 hover:bg-gray-400 hover:text-white rounded-md p-1"
                />
                <h1 className="text-2xl font-bold text-gray-800 mb-4">Sign Up</h1>
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label className="block text-gray-600 mb-2">Username</label>
                        <input
                            type="text"
                            name="username"
                            value={formData.username}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-gray-600 mb-2">Email</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <div>
                        <label className="block text-gray-600 mb-2">Password</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            className="w-full p-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition"
                    >
                        Sign Up
                    </button>
                </form>
            </div>
        </div>
    );
};

export default SignUp;
